import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CaseManagementWorkRequestExhibitTypeAddComponent } from './case-management-work-request-exhibit-type-add.component';

const routes: Routes = [{ path: '', component: CaseManagementWorkRequestExhibitTypeAddComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CaseManagementWorkRequestExhibitTypeAddRoutingModule { }
